<template>
  <div
    class="truncate font-medium"
    :style="styling"
  >
    <p v-if="is_show_timestamp && contact.attributes.status === ProfileRecord.STATUS_ACTIVE">
      {{ $t('contact.labels.last_login') }}:
      {{ getDateWithTime(contact.attributes.session_started_at) }}
    </p>
    <p v-else-if="is_show_timestamp && contact.attributes.status === ProfileRecord.STATUS_INVITED">
      {{
        $t('constants.profile_statuses_descriptive.invited_at', {
          invited_at: getDateWithTime(contact.attributes.invited_at),
        })
      }}
    </p>
    <p v-else>
      {{ $t(`contact.labels.contact_status.${contact.attributes.status}`) }}
    </p>
  </div>
</template>

<script>
import { ProfileRecord } from '@/app/data/model_constants';
import { getDateWithTime } from '@/app/util/date_fns';

export default {
  name: 'ContactStatus',

  props: {
    contact: { type: Object, required: true },
    is_show_timestamp: { type: Boolean },
    size: {
      type: String,
      default: 'normal',
      validator: (val) => ['normal', 'small'].includes(val),
    },
  },

  data() {
    return {
      getDateWithTime,
      ProfileRecord,
    };
  },

  computed: {
    styling() {
      const font_size = this.size === 'small' ? '0.75rem' : '1em';
      return `
        padding: 0 0.75em;
        border-radius: 9999px;
        height: 2em;
        font-size: ${font_size};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: ${ProfileRecord.STATUS_STYLES[this.contact.attributes.status]};
        color: ${ProfileRecord.STATUS_STYLES_TEXT[this.contact.attributes.status]};
      `;
    },
  },
};
</script>
